import { useEffect } from 'react'
import styled from 'styled-components'
import { ROUTES } from '../../routes'
import { Navbar, Redirect } from '../../components'
import { useConfigContextInfo } from '../../contexts/ConfigContext'
import { useNavbar } from '../../contexts/NavbarContext'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`

const ProtectedRoute = ({ View, restrictions }) => {
  const context = useConfigContextInfo()
  const { showNavbar } = useNavbar()

  useEffect(() => {
    const fetchConfig = async () => {
      await context?.fetchData()
    }

    fetchConfig()
  }, [])

  if (!context?.plan || !context?.role) {
    return <div>Carregando</div>
  }

  const isAllowed = ({ plans, roles }) => {
    return (
      hasRequiredAttribute(plans, context?.plan) &&
      hasRequiredAttribute(roles, context?.role)
    )
  }

  const hasRequiredAttribute = (requirements, attribute) => {
    return !requirements || requirements.includes(attribute)
  }

  return isAllowed(restrictions) ? (
    <Container>
      {showNavbar && <Navbar />}
      <View />
    </Container>
  ) : (
    <Redirect pathname={ROUTES.USER_DASHBOARD} />
  )
}

export default ProtectedRoute
